import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils/cn";

const labelVariants = cva(
  "text-muted-foreground text-xs leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const LabelText = ({ children }: { children: string }) => (
  <>
    {children.split(/\s*\*/).map((text, index) => (
      <React.Fragment key={index}>
        {index > 0 && (
          <>
            {" "}
            <span className="text-destructive">*</span>
          </>
        )}
        {text}
      </React.Fragment>
    ))}
  </>
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, children, asChild, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    asChild={asChild}
    {...props}
  >
    {asChild
      ? children
      : React.Children.map(children, (child) =>
          typeof child === "string" ? <LabelText>{child}</LabelText> : child,
        )}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label, LabelText };
